module.exports = __webpack_public_path__ + "9286653f04ef80a96eb8645c5a837d10.woff";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/Roboto-Bold-webfont.woff
// module id = 218
// module chunks = 0